jQuery(document).ready(function ($) { // wait for document ready
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function(){
        clearTimeout(doit);
        doit = setTimeout(setupFamilyTrustsPage, 100);
    };
    setupFamilyTrustsPage();
    function resetScrollMagic() {
        controller.destroy('reset');
        controller = null;
        $.each(scenes,function(k,scene) {
            scenes[k].destroy('reset');
            scenes[k] = null;
        });
        controller = new ScrollMagic.Controller({});
    }
    var curSize = '';
    function setupFamilyTrustsPage() {
        var windowWidth = $(window).outerWidth();
        var newSize = 'desktop';
        if (windowWidth <= 767) {
            newSize = 'mobile';
        }
        else if (windowWidth <= 1279) {
            newSize = 'tablet';
        }
        if (curSize == newSize)
            return true;


        curSize = newSize;
        var headerHeight;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        headerHeight = $('.page-header').outerHeight();
        if (curSize == 'mobile' && $('.page-template-services_family-trusts').length) {
        }
        else if (curSize == 'tablet' && $('.page-template-services_family-trusts').length) {
            var adminBarHeight = 0;
            if ($('#wpadminbar').length) {
                headerHeight += $('#wpadminbar').outerHeight();
                adminBarHeight += $('#wpadminbar').outerHeight();
            }
            if (cookieVal != 'dismissed') {
                scenes.push(new ScrollMagic.Scene({triggerElement: "#slide2"})
                    // trigger animation by adding a css class
                    .setClassToggle($('.cta-floating')[0], "visible")
                    .addTo(controller));
            }
            else {
                delete_cookie('notice-dismissed'); 
            }
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#sliding-text',
                duration: "25%",
                offset: -1 * headerHeight
            })
                .setPin('#sliding-text', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide2',
                duration: function() {
                    var imagesHeight = $('#imagerow1').outerHeight() + $('#imagerow2').outerHeight() + $('#imagerow3').outerHeight() + 4;
                    if ($(window).innerHeight() - headerHeight > imagesHeight)
                        return $(window).innerHeight() - (imagesHeight) - headerHeight;
                    else
                        return imagesHeight;
                },
                offset: -1 * headerHeight
            })
                .setPin('#slide2', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            // slide image - image 1
            $('#slideImage1,#slideImage2,#slideImage3,#slideText1,#slideText2,#slideText3').css('position','relative');
            var slideImage1 = TweenMax.fromTo("#slideImage1", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideImage2 = TweenMax.fromTo("#slideImage2", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideImage3 = TweenMax.fromTo("#slideImage3", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );

            var slideText1 = TweenMax.fromTo("#slideText1", 1,
                {left: '100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideText2 = TweenMax.fromTo("#slideText2", 1,
                {left: '-100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideText3 = TweenMax.fromTo("#slideText3", 1,
                {left: '100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );

            var diff = Math.round($(window).outerHeight() / 2);
            var startOffset = Math.round(diff);

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight - startOffset
            })
                .setTween(slideImage1)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight - startOffset
            })
                .setTween(slideText1)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight + $('#slide2').outerHeight() - (startOffset + diff)
            })
                .setTween(slideImage2)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight + $('#slide2').outerHeight() - (startOffset + diff)
            })
                .setTween(slideText2)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight + 2 * $('#slide2').outerHeight() - (startOffset + diff * 2)
            })
                .setTween(slideImage3)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight + 2 * $('#slide2').outerHeight() - (startOffset + diff * 2)
            })
                .setTween(slideText3)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide3',
                duration: "200%",
                offset: -1 * headerHeight
            })
                .setPin('#slide3', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onEnter',
                duration: "183.5%",
                triggerElement: "#slide3",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide3').closest('.slide-3-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onLeave',
                duration: "83.5%",
                triggerElement: "#slide4",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide4').closest('.slide-4-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onLeave',
                duration: "200%",
                triggerElement: "#slide5",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide5').closest('.slide-5-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide4',
                duration: "110%",
                offset: -1 * headerHeight
            })
                .setPin('#slide4', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide5',
                duration: "100%",
                offset: -1 * headerHeight
            })
                .setPin('#slide5', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));


            // pin slide7 and don't push followers

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide7',
                duration: "200%",
                offset: -1 * headerHeight
            })
                .setPin('#slide7', {pushFollowers: false})
                .addTo(controller));

            $('#slide7').find('.box:eq(0)').css('opacity',0);
            var slide7FadeInBox = TweenMax.fromTo($('#slide7').find('.box')[0], 1,
                {opacity: 0, left: '50vw'},
                {opacity: 1, left: 0, ease: Circ.easeInOut});
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0.5,
                triggerElement: '#slide7',
                duration: 0,
                offset: -1 * headerHeight
            })
                .setTween(slide7FadeInBox)
                .addTo(controller));

            $('#slide8').css('opacity',0);
            // fade in slide 8 and fade out slide 7 when slide 8 comes in
            var slide7FadeOut = TweenMax.fromTo("#slide7", 1,
                {opacity: 1},
                {opacity: 0, ease: Circ.easeInOut}
            );
            var slide8FadeIn = TweenMax.fromTo("#slide8", 1,
                {opacity: 0},
                {opacity: 1, ease: Circ.easeInOut}
            );

            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide8',
                offset: -1 * (headerHeight),
                triggerHook: 0,
                duration: 0
            })
                .setTween(slide7FadeOut)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide8',
                offset: -1 * (headerHeight),
                triggerHook: 0,
                duration: 0
            })
                .setTween(slide8FadeIn)
                .setClassToggle("#slide8", "active") // add class toggle
                .addTo(controller));

            // right after the slide 8 fade in, sequentially bring in the items from the bottom

            // pin slide8 and push followers

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide8',
                duration: "100%",
                offset: -1 * headerHeight
            })
                .setPin('#slide8', {pushFollowers: true})
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide9',
                duration: "100%",
                offset: -1 * headerHeight - 30
            })
                .setPin('#slide9', {pushFollowers: true})
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#title-pin-1',
                duration: function() {
                    return $('#text-pin-1').outerHeight() - $('#title-pin-1').outerHeight();
                },
                offset: -1 * headerHeight
            })
                .setPin('#title-pin-1', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#title-pin-2',
                duration: function() {
                    return $('#text-pin-2').outerHeight() - $('#title-pin-2').outerHeight();
                },
                offset: -1 * headerHeight
            })
                .setPin('#title-pin-2', {pushFollowers: false})
                .addTo(controller));


        }
        else if (curSize == 'desktop' && $('.page-template-services_family-trusts').length) {
            var adminBarHeight = 0;
            if ($('#wpadminbar').length) {
                headerHeight += $('#wpadminbar').outerHeight();
                adminBarHeight += $('#wpadminbar').outerHeight();
            }
            if (cookieVal != 'dismissed') {
                scenes.push(new ScrollMagic.Scene({triggerElement: "#slide2"})
                    // trigger animation by adding a css class
                    .setClassToggle($('.cta-floating')[0], "visible")
                    .addTo(controller));
            }
            else {
                delete_cookie('notice-dismissed');
            }
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#sliding-text',
                duration: "25%",
                offset: -1 * headerHeight
            })
                .setPin('#sliding-text', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide2',
                duration: "100%",
                offset: -1 * headerHeight + 45
            })
                .setPin('#slide2', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            // slide image - image 1
            $('#slideImage1,#slideImage2,#slideImage3,#slideText1,#slideText2,#slideText3').css('position','relative');
            var slideImage1 = TweenMax.fromTo("#slideImage1", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideImage2 = TweenMax.fromTo("#slideImage2", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideImage3 = TweenMax.fromTo("#slideImage3", 1,
                {top: '100%', opacity: 0},
                {top: 0, opacity: 1, ease: Circ.easeInOut}
            );

            var slideText1 = TweenMax.fromTo("#slideText1", 1,
                {left: '100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideText2 = TweenMax.fromTo("#slideText2", 1,
                {left: '-100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );
            var slideText3 = TweenMax.fromTo("#slideText3", 1,
                {left: '100%', opacity: 0},
                {left: 0, opacity: 1, ease: Circ.easeInOut}
            );

            var startOffset = 200;
            var diff = 600;

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight - startOffset
            })
                .setTween(slideImage1)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight - startOffset
            })
                .setTween(slideText1)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight + $('#slide2').outerHeight() - (startOffset + diff)
            })
                .setTween(slideImage2)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight + $('#slide2').outerHeight() - (startOffset + diff)
            })
                .setTween(slideText2)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '50%',
                offset: -1 * headerHeight + 2 * $('#slide2').outerHeight() - (startOffset + diff * 2)
            })
                .setTween(slideImage3)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerElement: "#slide2",
                duration: '25%',
                offset: -1 * headerHeight + 2 * $('#slide2').outerHeight() - (startOffset + diff * 2)
            })
                .setTween(slideText3)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide3',
                duration: "200%",
                offset: -1 * headerHeight
            })
                .setPin('#slide3', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onEnter',
                duration: "183.5%",
                triggerElement: "#slide3",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide3').closest('.slide-3-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onLeave',
                duration: "83.5%",
                triggerElement: "#slide4",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide4').closest('.slide-4-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 'onLeave',
                duration: "200%",
                triggerElement: "#slide5",
                offset: -1 * headerHeight
            })
                // trigger animation by adding a css class
                .setClassToggle($('#slide5').closest('.slide-5-wrap')[0], "active")
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide4',
                duration: "110%",
                offset: -1 * headerHeight
            })
                .setPin('#slide4', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide5',
                duration: "100%",
                offset: -1 * headerHeight
            })
                .setPin('#slide5', {pushFollowers: true})
                // .addIndicators() // add indicators (requires plugin)
                .addTo(controller));


            // pin slide7 and don't push followers

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide7',
                duration: "200%",
                offset: -1 * headerHeight
            })
                .setPin('#slide7', {pushFollowers: false})
                .addTo(controller));

            $('#slide7').find('.box:eq(0)').css('opacity',0);
            var slide7FadeInBox = TweenMax.fromTo($('#slide7').find('.box')[0], 1,
                {opacity: 0, left: '50vw'},
                {opacity: 1, left: 0, ease: Circ.easeInOut});
            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0.5,
                triggerElement: '#slide7',
                duration: 0,
                offset: -1 * headerHeight
            })
                .setTween(slide7FadeInBox)
                .addTo(controller));

            $('#slide8').css('opacity',0);
            // fade in slide 8 and fade out slide 7 when slide 8 comes in
            var slide7FadeOut = TweenMax.fromTo("#slide7", 1,
                {opacity: 1},
                {opacity: 0, ease: Circ.easeInOut}
            );
            var slide8FadeIn = TweenMax.fromTo("#slide8", 1,
                {opacity: 0},
                {opacity: 1, ease: Circ.easeInOut}
            );

            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide8',
                offset: -1 * (headerHeight),
                triggerHook: 0,
                duration: 0
            })
                .setTween(slide7FadeOut)
                .addTo(controller));
            scenes.push(new ScrollMagic.Scene({
                triggerElement: '#slide8',
                offset: -1 * (headerHeight),
                triggerHook: 0,
                duration: 0
            })
                .setTween(slide8FadeIn)
                .setClassToggle("#slide8", "active") // add class toggle
                .addTo(controller));

            // right after the slide 8 fade in, sequentially bring in the items from the bottom

            // pin slide8 and push followers

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide8',
                duration: "100%",
                offset: -1 * headerHeight
            })
                .setPin('#slide8', {pushFollowers: true})
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#slide9',
                duration: "100%",
                offset: -1 * headerHeight
            })
                .setPin('#slide9', {pushFollowers: true})
                .addTo(controller));

            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#title-pin-1',
                duration: function() {
                    return $('#text-pin-1').outerHeight() - $('#title-pin-1').outerHeight();
                },
                offset: -1 * headerHeight
            })
                .setPin('#title-pin-1', {pushFollowers: false})
                .addTo(controller));


            scenes.push(new ScrollMagic.Scene({
                triggerHook: 0,
                triggerElement: '#title-pin-2',
                duration: function() {
                    return $('#text-pin-2').outerHeight() - $('#title-pin-2').outerHeight();
                },
                offset: -1 * headerHeight
            })
                .setPin('#title-pin-2', {pushFollowers: false})
                .addTo(controller));
        }
    }
});